import React from "react";
import { Sidenav } from "rsuite";
import "../styles/SideContact.css";
import "react-typist/dist/Typist.css";
import FadeInSection from "./FadeIn";

const isMobile = window.innerWidth < 600;

class SideContact extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const { expanded } = this.state;

    const links = [
      <a href="mailto:cristian4402@gmail.com">
        <img src="https://user-images.githubusercontent.com/93356900/232889895-70492a25-35c6-4ed4-934d-babbf673dbb2.png" alt="bitmoji" />
        <p>Contact me</p>
      </a>
    ];

    return (
      <div className="sidebar-nav">
        {!isMobile && (
          <Sidenav
            expanded={expanded}
            defaultOpenKeys={["3", "4"]}
            activeKey={this.state.activeKey}
            onSelect={this.handleSelect}
            appearance={"subtle"}
          >
            <Sidenav.Body>
              <div className="sidebar-contact">
                {links.map((link, i) => (
                  <FadeInSection delay={`${i + 1}00ms`}>
                    <div>{link}</div>
                  </FadeInSection>
                ))}
              </div>
            </Sidenav.Body>
          </Sidenav>
        )}
      </div>
    );
  }
}

export default SideContact;